import {ChangeDetectorRef, Component, Input, NgZone} from "@angular/core";

import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {QuestionReportEvent} from "./QuestionReportEvent";

import {PipelineService} from "../services/pipeline/pipeline.service";
import {HttpClient} from "@angular/common/http";
import {filter} from "rxjs/operators";

@Component({
               selector: "question-report-modal",
               templateUrl: "./question.report.modal.component.html",
               styleUrls: ["./pipeline.component.scss"]
           })
export class QuestionReportModalComponent extends ComponentBase {

    public activateModal: boolean = false;
    public status:string = "";
    public questions:Array<any> = new Array<any>();
    public search: string;
    public filterNew: boolean = false;
    public filterPublished: boolean = false;
    public fromATOS:number = 0;
    public toATOS:number = 16;
    public isLoading:boolean = false;

    constructor(private http: HttpClient,
                private eventBus: EventBus,
                private modalConfig: ModalConfig,
                private logService: BugsnagLoggingService,
                private _ngZone: NgZone,
                private pipelineService:PipelineService,
                private ref: ChangeDetectorRef
    ) {
        super("QuestionReportModalComponent");
        this.subscribeObserve();
    }

    private subscribeObserve():void {
        let sub = this.eventBus.pipe(filter((e:QuestionReportEvent) => (e.type === QuestionReportEvent.TYPE))).subscribe((e:QuestionReportEvent) => {
            console.log("activating question report modal refactored");

            this.isLoading = true;
            this.pipelineService.getQuestionReport().subscribe(response => {
                this.questions = Array<any>(response);
                this.isLoading = false;
            });

            this.activateModal = true;
        });
        this.subscriptions.push(sub);
    }

    public closeModal(): void {
        this.activateModal = false;
    }

    public filterATOS():void {
        this.isLoading = true;
        this.pipelineService.getQuestionReport().subscribe(response => {
            this.questions = new Array<any>();
            let tempQuestions:Array<any> = Array<any>(response);
            tempQuestions.forEach( value => {
                if ((parseFloat(value.atos) >= this.fromATOS) && (parseFloat(value.atos) <= this.toATOS)) {
                    this.questions.push(value);
                }
            })
            this.ref.detectChanges();
            this.isLoading = false;
        });
    }

    public clearFilter():void {
        this.fromATOS = 0;
        this.toATOS = 16;
        this.questions = new Array<any>();
        this.isLoading = true;
        this.pipelineService.getQuestionReport().subscribe(response => {
            this.questions = Array<any>(response);
            this.ref.detectChanges();
            this.isLoading = false;
        });

    }

}
